import { Directive, HostListener, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UtilsService } from '../services/utils.service';

@Directive({
  selector: '[limitNumber]',
  standalone:true,
})
export class LimitNumberDirective {

  constructor(private utils: UtilsService) { }

  @Input('limitTo') limitTo: any;
  @Input('limitPhoneNum') limitPhoneNum: boolean = false;
  @Input('formGroup') FormGroup!: FormGroup;
  @Input('limitNumberObj') limitNumberObj: any;

  @HostListener('keypress', ['$event'])
  _onKeypress(e: any) {
    this.keyHandler(e);
  }

  keyHandler(event: any) {
    // let value = event.keyCode || event.charCode || event.which;
    if (!this.checkNumber(event.key)) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    else if (event.key === '0' && this.limitNumberObj.limitPhoneNum && (!event.target.value.length || event.target.value.length == Number(this.limitNumberObj.limitTo))) {
      event.preventDefault();
    }
  }

  checkNumber(value: any): any {
    return this.utils.numRegex.exec(value) ? true : false;
  }

  // block paste in number field
  @HostListener('paste', ['$event']) blockPaste(e: any) {
    let pastedData = e.clipboardData.getData('Text');
    this.processPaste(e, pastedData);
    // e.target.innerHTML += finalPasteValue;
    e.stopPropagation();
    e.preventDefault();
    return false;
  }

  processPaste(editableInput: any, pastedData: any) {
    let arr = pastedData.split('');
    let value = arr.filter((x: any) => {
      if (this.checkNumber(x)) {
        return x;
      }
    }).join('');
    let finalPasteValue = this.limitNumberObj.limitPhoneNum ? value.replace(/^0+/, '') : value;
    if (String(finalPasteValue).length > this.limitNumberObj.limitTo) {
      finalPasteValue = finalPasteValue.substring(finalPasteValue.length - this.limitNumberObj.limitTo)
    }
    editableInput.target.value = finalPasteValue;
    let formControlName = editableInput.target.getAttribute('formControlName') ? editableInput.target.getAttribute('formControlName') : this.limitNumberObj.formControlName;
    if (formControlName) {
      if (finalPasteValue) {
        this.limitNumberObj.formGroup.controls[formControlName].setValue(finalPasteValue);
        this.limitNumberObj.formGroup.controls[formControlName].setErrors(null);
        if (finalPasteValue.length != this.limitNumberObj.limitTo) {
          finalPasteValue.length < this.limitNumberObj.limitTo ? this.limitNumberObj.formGroup.controls[formControlName].setErrors({
            minlength: {
              actualLength: finalPasteValue,
              requiredLength: this.limitNumberObj.limitTo
            }
          }) : this.limitNumberObj.formGroup.controls[formControlName].setErrors({
            maxlength: {
              actualLength: finalPasteValue,
              requiredLength: this.limitNumberObj.limitTo
            }
          })
        }
      }
      else {
        this.limitNumberObj.formGroup.controls[formControlName].setErrors({ required: true })
      }
    }
  }
}
